import { memo } from 'react';

import { cn } from '../../lib/styles/styles.lib';

interface ActionBarProps {
  children: React.ReactNode;
  className?: string;
  visible?: boolean;
}

export const ActionBarLeft = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}

      <div className="w-px h-4 bg-gray-12" />
    </>
  );
};

export const ActionBarRight = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <div className="w-px h-4 bg-gray-12" />

      {children}
    </>
  );
};

const ActionBarBase = ({ children, className, visible = false }: ActionBarProps) => {
  return (
    <div
      className={cn(
        'flex items-center gap-4 px-3 py-1 bg-bg-inter-primary-default rounded-sm h-12 shadow-md',
        'transition-all duration-300 ease-out',
        visible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-full opacity-0 pointer-events-none',
        className,
      )}
    >
      {children}
    </div>
  );
};

export const ActionBar = memo(ActionBarBase);
